import { defaultHttpClient } from '../../httpClient';
import type { GoodsContactsResponse } from './types';

/**
 * - 상품 문의(1:1) 화면에서 쓰는 "이 상품을 주문한 내역" 조회 API
 * - GET /api/v2/goods/{sno}/contacts/
 */
export const getGoodsContacts = (goodsSno: number) => {
  return defaultHttpClient
    .request<GoodsContactsResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/contacts/`,
    })
    .then(result => result.data);
};
